import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {
    prefectures: [],
  }
}

const state = getDefaultState()

const mutations = {
  SET_PREFECTURES(state, payload) {
    state.prefectures = payload
  },
}

const actions = {
  async getPrefectures({ commit }, payload) {
    const apiResult = await apiService.get(route('member.prefecture.index'), payload)
    if (apiResult?.success && apiResult?.data) {
      commit('SET_PREFECTURES', apiResult.data)

      return apiResult.data
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
